import { ReactElement } from 'react';

import { ConfidentialResourceAccessRequest } from '@dreryk/egabinet-medical-data-confidentiality-frontend-api';

import { Link, StyledFlex } from '@dreryk/react-components';
import { createTranslatedText, patientNameFormatter, Translate, useTranslateDeclension } from '@dreryk/react-common';

import { systemActivityTranslationKeys } from '../../translations';

import { ConfidentialResourcesModalOpener } from './ConfidentialResourcesModal/ConfidentialResourcesModal.opener';
import { StyledResourceTypeCellSecondaryText } from './ResourceTypeCell.styled';

type MedicalDocumentationGenerationResourceTypeCellProps = {
   confidentialResourceAccessRequest: ConfidentialResourceAccessRequest;
};

export const MedicalDocumentationGenerationResourceTypeCell = (
   props: MedicalDocumentationGenerationResourceTypeCellProps
): ReactElement => {
   const { confidentialResourceAccessRequest } = props;

   const count = confidentialResourceAccessRequest.confidentialResources.length;
   const confidentialVisitsSuffix = useTranslateDeclension(
      count || 1,
      systemActivityTranslationKeys.confidentialVisitAccusative,
      systemActivityTranslationKeys.confidentialVisitGenitive,
      systemActivityTranslationKeys.confidentialVisitPlural
   );

   return (
      <StyledFlex direction={'column'}>
         <Translate>
            {systemActivityTranslationKeys.resourceTypeMap[confidentialResourceAccessRequest.resourceType]}
         </Translate>
         <ConfidentialResourcesModalOpener request={confidentialResourceAccessRequest}>
            {({ openModal }) => (
               <Link
                  testId={'confidentialResourcesLink'}
                  label={createTranslatedText(`${count} ${confidentialVisitsSuffix}`)}
                  onClick={openModal}
               />
            )}
         </ConfidentialResourcesModalOpener>
         <StyledResourceTypeCellSecondaryText>
            {patientNameFormatter(confidentialResourceAccessRequest.patient)}
         </StyledResourceTypeCellSecondaryText>
      </StyledFlex>
   );
};
